module.exports = __webpack_public_path__ + "img/amazon-pay.3b2fcca.svg";